import script from "./password.vue?vue&type=script&lang=ts&setup=true"
export * from "./password.vue?vue&type=script&lang=ts&setup=true"

import "./password.vue?vue&type=style&index=0&id=7dea9a8e&scoped=true&lang=css"

import exportComponent from "/Users/niming/Documents/vue-mooc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7dea9a8e"]])

export default __exports__